function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Warstwa 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.41 0L6 4.38 10.59 0 12 1.35 6 7.09 0 1.35z",
  "data-name": "Warstwa 1"
}));

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 7.09"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiA3LjA5Ij48ZyBpZD0iV2Fyc3R3YV8yIiBkYXRhLW5hbWU9IldhcnN0d2EgMiI+PGcgaWQ9IldhcnN0d2FfMS0yIiBkYXRhLW5hbWU9IldhcnN0d2EgMSI+PHBhdGggaWQ9IkFycm93IiBkPSJNMS40MSwwLDYsNC4zOCwxMC41OSwwLDEyLDEuMzUsNiw3LjA5LDAsMS4zNVoiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgArrow as ReactComponent };